export default __webpack_public_path__ + "static/media/emoji-23-icon.586f01c6.png";